import React from "react";
import { Button } from "@/components/Button";
import { Slider } from "@/components/Slider";
import { addCurrencyWord } from "@/utils";
import { ProductCardPropsType } from "./types";
import imgPlaceholder from "@/assets/img/imgPlaceholder.jpg";
import styles from "./ProductCard.module.scss";

export const ProductCard: React.FC<ProductCardPropsType> = ({
  product,
  onAddToCart,
  onRemoveFromCart,
  quantity,
}) => {
  const hasImages = product.images && product.images.length > 0;

  const handleIncrement = () => {
    onAddToCart(product);
  };

  const handleDecrement = () => {
    if (quantity > 0) {
      onRemoveFromCart(product.productId);
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        {hasImages ? (
          <div className={styles.sliderWrapper}>
            <Slider images={product.images} />
          </div>
        ) : (
          <img
            src={imgPlaceholder}
            alt={product.productName}
            className={styles.image}
          />
        )}
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>
          {product.productName}
        </h3>
        <div className={styles.footer}>
          <div className={styles.price}>{addCurrencyWord(product.price)}/шт.</div>
          <div className={styles.actions}>
            {quantity > 0 ? (
              <div className={styles.counter}>
                <button
                  className={styles.counterButton}
                  onClick={handleDecrement}
                  aria-label="Уменьшить количество"
                >
                  −
                </button>
                <span className={styles.counterValue}>{quantity}</span>
                <button
                  className={styles.counterButton}
                  onClick={handleIncrement}
                  aria-label="Увеличить количество"
                >
                  +
                </button>
              </div>
            ) : (
              <Button
                onClickFunc={handleIncrement}
                newStyles={styles.addButton}
              >
                Добавить в корзину
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

